import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../../common/CustomComponents/RowContainer';
import { useLocation } from 'react-router-dom';

const ClaimDetails = () => {
  const location = useLocation();
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  const memberAccountHeader = location.state?.memberAccountHeader;

  return (
    tenantLayouts['ClaimDetails'] && (
      <div
        className={tenantLayouts['ClaimDetails'].className}
        id={tenantLayouts['ClaimDetails'].id}
      >
        {tenantLayouts['ClaimDetails'].sections.map((item, index) => {
          return <RowContainer key={index} {...item} memberAccountHeader={memberAccountHeader} />;
        })}
      </div>
    )
  );
};

export default ClaimDetails;
